import { useCallback, useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logError } from '../../../../utils/logger';
import { Loader, SectionTitle } from '../../../shared/components';
import JobPostingTable from '../components/JobPostingTable';
import { getAllJobPostings } from '../hiringRequest.service';

export default function HiringRequestsPage() {
  const [loadCount, setLoadCount] = useState(0);
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllJobPostings = useCallback(async () => {
    setLoading(true);
    try {
      const jobs = await getAllJobPostings();
      setJobPostings(jobs);
      setLoadCount((p) => p + 1);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch job postings',
          error: err,
          code: 'JOB_POST_FETCH_FAILED',
        })
      );
      setJobPostings([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllJobPostings();
  }, [fetchAllJobPostings]);

  return (
    <>
      <div className='column gap-5'>
        <SectionTitle
          title='Hiring Requests'
          action={
            <Link to='/hiring-request/new' className='btn cta-outlined-btn'>
              + Hiring Request
            </Link>
          }
        />
        {loading && loadCount < 2 ? (
          <Loader />
        ) : (
          <JobPostingTable postings={jobPostings} onUpdate={fetchAllJobPostings} />
        )}
        <Outlet context={{ jobPostings, onRefresh: fetchAllJobPostings }} />
      </div>
    </>
  );
}
